module.exports = __webpack_public_path__ + "media/images/tools/revenues-blured-56ecc538e720a047ee39cc429f86e582.jpg";